import React from 'react';

import { RightSidebar } from "../../../_partials/Layout";
import { UserInterface } from "../../../../store/sticker_maker/usersSlice";
import RowInfo from "../../../../componets/RowInfo";
import { formatterToUnits } from "../../../../helpers/NumberHelper";
import { formattedDate } from "../../../../helpers/DateHelpers";

const _SidebarShow = ({ user }: { user: UserInterface | undefined }) => {
  const renderDetails = () => {
    if(!user) {
      return null;
    }

    const renderDate = (date: string) => {
      const prepared = formattedDate(date);

      return <small>{prepared.date} <small>{prepared.time}</small></small>
    }

    return (
      <>
        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Base Information</h6>

          <RowInfo left='#ID' right={user.id} />

          <RowInfo left='Launch at' right={renderDate(user.launch_at)} />
          <RowInfo left='Previous launch at' right={renderDate(user.last_launch_at)} />
          <RowInfo left='Launch count' right={formatterToUnits(user?.launch_count || 0, 1)} />
        </div>
      </>
    )
  }

  return (
    <RightSidebar>
      <h6 className='v-content-label'>CHOOSE OPTION</h6>
      <hr className="v-divider" />

      {renderDetails()}
    </RightSidebar>
  )
}

export default _SidebarShow;
